import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface PromptResponse {
  name: string;
  path: string;
  type: string;
  success?: boolean;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PromptsService {
  constructor(private http: HttpClient) {}

  public load = (teamName: string) => this.http.get(`${ConfigService.apiUrl}/prompts/${teamName}`);

  public remove = (teamName: string, path: string) =>
    this.http.delete(`${ConfigService.apiUrl}/prompts/${teamName}`, { body: { path } });

  public duplicate = (teamName: string, path: string, newName: string) =>
    this.http.post(`${ConfigService.apiUrl}/prompts/${teamName}/duplicate`, { path, newName });
    
  public add = (teamName: string, name: string, content: string, type: string = 'txt'): Observable<PromptResponse> =>
    this.http.post<PromptResponse>(`${ConfigService.apiUrl}/prompts/${teamName}`, { name, content, type });
}
